/**
 * NotFoundPage — catch-all for any URL not matched by other routes.
 * Keeps the arcade tone (404 → "GAME OVER · CONTINUE?").
 */
import { useLocation } from 'react-router-dom';
import { GlassButton } from '@/components/GlassButton';
import { Icon } from '@/components/Icon';

export function NotFoundPage(): JSX.Element {
  const location = useLocation();
  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-5 py-12">
      <div className="text-center max-w-md">
        <Icon name="search" size={48} className="text-ember-400 mx-auto mb-3" />
        <div className="font-score text-7xl md:text-9xl text-neon text-chromatic" style={{ color: '#ff2e88' }}>
          404
        </div>
        <div className="mt-3 font-arcade tracking-widest text-honey-300 text-sm">
          GAME OVER · CONTINUE?
        </div>
        <p className="mt-6 text-sm text-cream-400">
          找不到这条路：<span className="font-mono text-cream-300 break-all">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <GlassButton to="/" size="md" variant="solid">回首页</GlassButton>
          <GlassButton to="/app" size="md">进入应用</GlassButton>
        </div>
      </div>
    </div>
  );
}
